import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from '../Services/auth.service';
import { PERMISSIONS } from '../../../Enums/permission.enum';

export const permissionGuard: CanActivateFn = (route) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const requiredPermission: PERMISSIONS | PERMISSIONS[] | undefined = route.data?.['permission'];

    if (!requiredPermission) {
        return true;
    }

    return authService.initializeAuth().pipe(
        map(() => {
            const user = authService.getCurrentUser();

            if (!user?.hasPermission(requiredPermission)) {
                return router.createUrlTree(['/home']);
            }

            return true;
        })
    );
};
